import { Component, HostListener, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { HandsetService } from '../../../core/services/handset.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OnboardingService } from '../../services/onboarding.service';
import { SliderComponent } from '../../../shared/components/slider/slider.component';
import { SliderStoreService } from '../../../shared/services/slider.service';
import { IComponentSliderConfig } from '../../../shared/models/slider.model';
import { Subscription } from 'rxjs';
import { OnboardingStep } from '../../services/onboarding-store.service';
import { LoaderButtonType } from '../../../shared/models/loader-button-type.enum';

interface StepData {
  step: OnboardingStep;
}

@Component({
standalone: false,
  selector: 'app-onboarding',
  styleUrls: ['./onboarding.component.scss'],
  templateUrl: './onboarding.component.html',
})
export class OnboardingComponent implements OnInit, OnDestroy {
  public step: OnboardingStep;
  public finished = false;
  public loading = true;
  public sliderConfig: IComponentSliderConfig;
  private isMobileSubscription: Subscription;
  public isMobile: boolean;

  @ViewChild(SliderComponent) public sliderComponent: SliderComponent;

  constructor(public handsetService: HandsetService,
              @Inject(MAT_DIALOG_DATA) private data: StepData,
              public dialogRef: MatDialogRef<OnboardingComponent>,
              public onboardingService: OnboardingService,
              private store: SliderStoreService) {
    this.step = data.step;
  }


  ngOnInit(): void {
    this.getSliderConfig();
    this.isMobileSubscription = this.handsetService.mobileChanges.subscribe(value => {
      if (value !== this.isMobile) {
        this.isMobile = value;
        if (this.showOnboardingSliders) {
          this.resizeSliderDialog(value);
        } else {
          this.resizeNickDialog(value);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.isMobileSubscription.unsubscribe();
  }

  get showNick() {
    return this.step === 'WELCOME';
  }

  private getSliderConfig() {
    this.store.getState().subscribe(
      value => {
        if (value !== null) {
          this.sliderConfig = value.find(value1 => value1.component === 'Onboarding').config;
        }
      });
  }

  get showOnboardingSliders() {
    return this.step === 'SAVED_NICK';
  }

  @HostListener('document:keydown.escape', ['$event'])
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  handleKeyboardEvent(event: KeyboardEvent) {
    if (this.step !== 'WELCOME') {
      this.onClose();
    }
  }

  public onSavedNick() {
    this.onboardingService.changeStep('SAVED_NICK');
    this.step = 'SAVED_NICK';
    this.loading = true;
    this.resizeSliderDialog(this.isMobile);
  }

  public onLastSlideAction() {
    this.finished = true;
  }

  public onLoadedAction() {
    this.loading = false;
  }

  public onSkip() {
    this.onboardingService.skip().subscribe();
  }

  public onClose() {
    this.onboardingService.finish();
  }

  public onGoNext() {
    this.sliderComponent.onGoNext();
  }

  resizeNickDialog(mobile: boolean) {
    if (mobile) {
      const height = window.innerHeight < 725 ? '100%' : 'calc(100% - 64px)';
      const top = window.innerHeight < 725 ? '26px' : '90px';

      this.dialogRef.updateSize('100vw', height);
      this.dialogRef.updatePosition({ top: top });
      this.dialogRef.addPanelClass('no-border-radius');

    } else {
      this.dialogRef.updateSize('600px', '550px');
      this.dialogRef.updatePosition({ top: undefined });
      this.dialogRef.removePanelClass('no-border-radius');
    }
  }

  resizeSliderDialog(mobile: boolean) {
    if (mobile) {
      const height = window.innerHeight < 725 ? '100%' : 'calc(100% - 64px)';
      const top = window.innerHeight < 725 ? '26px' : '90px';

      this.dialogRef.updateSize('100vw', height);
      this.dialogRef.updatePosition({ top: top});
      this.dialogRef.addPanelClass('no-border-radius');

    } else {
      this.dialogRef.updateSize('600px', '550px');
      this.dialogRef.updatePosition({ top: undefined });
      this.dialogRef.removePanelClass('no-border-radius');
    }
  }

  protected readonly LoaderButtonType = LoaderButtonType;
}
